'use strict';

import angular from 'angular';

// import modalDirective from 'brg/rest/buttons/modal';
import modalDirective from 'incidents/components/buttons/rest-modal';

import viewTemplate from './view.html';

const MODULE_NAME = 'daupler.entities.jcw.buppQuestionnaires';

var app = angular.module(MODULE_NAME, [
]);
app.directive('viewJcwBuppQuestionnaire', modalDirective({
	template: viewTemplate,
	backdrop: true,
}));

export default MODULE_NAME;
